import logGAEvent from '../helpers/logGAEvent';

/**
 * This function logs an event to GA before redirecting
 * to the location specified with the href attribute
 * @param event
 */
const logEventThenRedirect = (event: Event) => {
  const target = event.target as HTMLAnchorElement;
  const href = target.getAttribute('href');
  const eventAction = target.getAttribute('data-ga-event');

  event.stopPropagation();
  event.preventDefault();

  logGAEvent(eventAction);

  if (href) {
    window.location.href = href;
  }
};

export default logEventThenRedirect;
